var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('router-link',{staticClass:"logo-link btn-link",attrs:{"to":_vm.nav.route}},[_c('span',{staticClass:"link logo"},[_c('img',{attrs:{"src":require("../assets/images/logo.svg"),"alt":`Logo Caroline Staeger`}})]),_c('span',{staticClass:"link-text"},[_vm._v(_vm._s(_vm.nav.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }